import { hasPermission, canCreate, canRead, canUpdate, canDelete, canApprove, canImport } from '@/utils/permissions';

export default {
  methods: {
    $hasPermission(menuCode, action) {
      return hasPermission(menuCode, action);
    },
    $canCreate(menuCode) {
      return canCreate(menuCode);
    },
    $canRead(menuCode) {
      return canRead(menuCode);
    },
    $canUpdate(menuCode) {
      return canUpdate(menuCode);
    },
    $canDelete(menuCode) {
      return canDelete(menuCode);
    },
    $canApprove(menuCode) {
      return canApprove(menuCode);
    },
    $canImport(menuCode) {
      return canImport(menuCode);
    }
  }
};
